import {
  addBlacklistRequestSchema,
  blacklistEntrySchema,
  blacklistListResponseSchema,
  type AddBlacklistRequest,
} from "@chotca/config";
import { z } from "zod";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createBlacklistResource(ctx: RequestContext) {
  return {
    list() {
      return requestJson(ctx, {
        method: "GET",
        path: "/me/blacklist",
        dataSchema: blacklistListResponseSchema,
        auth: true,
      });
    },

    add(body: AddBlacklistRequest) {
      const payload = addBlacklistRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: "/me/blacklist",
        body: payload,
        dataSchema: blacklistEntrySchema,
        auth: true,
      });
    },

    remove(orgId: string) {
      return requestJson(ctx, {
        method: "DELETE",
        path: `/me/blacklist/${orgId}`,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },
  };
}
